import { UnauthApiClient } from "./apiclient";

export default class AppService extends UnauthApiClient {
  getInfo() {
    return this.GET("/info");
  }

  getLangs() {
    return this.GET("/langs");
  }

  getFlixxInfo() {
    return this.GET("/wallet/flixx/info");
  }
}
